import React from "react";
import { motion } from "framer-motion";
import { Apple, Download } from "lucide-react";

const LOGO_URL = "/logo1.png";
const APP_MOCKUP_URL = "/app-mockup.png";
const IOS_APP_URL = "https://apps.apple.com/app/id6761510970";
const ANDROID_APK_URL = "/downloads/apedir-pedidos-android-v2.0.4.apk";

const DownloadSection = () => {
  return (
    <section id="descargar" className="py-24 bg-primary relative overflow-hidden" data-testid="download-section">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left"
          >
            <motion.img
              src={LOGO_URL}
              alt="Apedir"
              className="h-20 w-auto mx-auto lg:mx-0 mb-6"
              animate={{
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />

            <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-white mb-6">
              Descarga Apedir Hoy
            </h2>

            <p className="text-lg text-white/80 mb-8 max-w-lg mx-auto lg:mx-0">
              Ya puedes descargar APEDIR en iPhone o instalar el APK oficial en Android
              para empezar a pedir desde tu celular.
            </p>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="inline-block mb-8"
            >
              <span className="bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wider">
                Disponible ahora
              </span>
            </motion.div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <motion.a
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="download-btn flex items-center gap-3 px-6 py-4 rounded-xl"
                data-testid="download-ios-button"
                href={IOS_APP_URL}
                target="_blank"
                rel="noreferrer"
              >
                <Apple className="w-8 h-8 text-white" />
                <div className="text-left">
                  <p className="text-xs text-white/70">Disponible en</p>
                  <p className="font-bold text-white">App Store</p>
                </div>
              </motion.a>

              <motion.a
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="download-btn flex items-center gap-3 px-6 py-4 rounded-xl"
                data-testid="download-android-button"
                href={ANDROID_APK_URL}
                download="APEDIR-pedidos-v2.0.4-vc31-actualizacion.apk"
              >
                <Download className="w-8 h-8 text-white" />
                <div className="text-left">
                  <p className="text-xs text-white/70">APK v2.0.4 actualizado</p>
                  <p className="font-bold text-white">Descargar App Android</p>
                </div>
              </motion.a>
            </div>

            <p className="mt-6 text-white/60 text-sm">
              Si quieres recibir novedades y promociones,{" "}
              <a href="#registro" className="text-white underline hover:no-underline">
                registrate aqui
              </a>
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex justify-center"
          >
            <motion.div
              animate={{
                y: [0, -20, 0],
                rotate: [0, 2, 0],
              }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="relative"
            >
              <img
                src={APP_MOCKUP_URL}
                alt="Apedir App Mockup"
                className="w-72 md:w-80 phone-mockup"
                data-testid="download-app-mockup"
              />

              <div className="absolute inset-0 bg-white/20 blur-3xl rounded-full scale-75 -z-10" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
